import BaseApi from './baseApi';
import IOutboundPicture from '../models/IOutboundPicture';
import IAuthentication from '../models/IAuthentication';
export default class OutboundPictureApi extends BaseApi {
    idUser : string = "";
    constructor(page: string) {
        super("dataaccess", page);
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetOutboundPictures(idOutbound: string) : Promise<IOutboundPicture[]> {
        let json : string = this.getJsonRead(idOutbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outboundPictures: IOutboundPicture[] = [];
            outboundPictures = response.data as IOutboundPicture[];
            return outboundPictures;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutboundPicture(outboundPicture: IOutboundPicture) : Promise<string> {
        const json = this.getJsonSave(outboundPicture);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutboundPicture(outboundPicture: IOutboundPicture) : Promise<boolean> {
        const json = this.getJsonUpdate(outboundPicture);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundPicture(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundPictureByOutboundId(outboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByOutboundId(outboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByOutboundId(outboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsPictures",
            "conditions": [{
                "Item1": "OutboundsPictures",
                "Item2": "idOutbound",
                "Item3": "=",
                "Item4": outboundId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsPictures",
            "conditions": [{
                "Item1": "OutboundsPictures",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(outboundPicture: IOutboundPicture) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "URL",
                "Item2": outboundPicture.url
            }, {
                "Item1": "idCompany",
                "Item2": outboundPicture.idCompany
            }, {
                "Item1": "idOutbound",
                "Item2": outboundPicture.idOutbound
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsPictures"
        };
        return json;
    }

    private getJsonUpdate(outboundPicture: IOutboundPicture) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "URL",
                "Item2": outboundPicture.url
            }, {
                "Item1": "idCompany",
                "Item2": outboundPicture.idCompany
            }, {
                "Item1": "idOutbound",
                "Item2": outboundPicture.idOutbound
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsPictures",
            "keyvalue": outboundPicture.id
        };
        return json;
    }

    private getJsonRead(idOutbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "OutboundsPictures",
                "Item2": "id"
            }, {
                "Item1": "OutboundsPictures",
                "Item2": "url"
            }, {
                "Item1": "OutboundsPictures",
                "Item2": "idOutbound"
            }, {
                "Item1": "OutboundsPictures",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "OutboundsPictures"
            }],
            "conditions": [{
                "Item1": "OutboundsPictures",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "OutboundsPictures",
                "Item2": "idOutbound",
                "Item3": "=",
                "Item4": idOutbound
            }]
        };
        return json;
    }
}
